import React, { Component, Fragment } from "react";
import Grid from "@material-ui/core/Grid";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import { citiesData } from "../utils/cities-data-no-stncode.js";
import { Config } from "../utils/Config";
import { LOCALSTORAGE_KEY } from "../utils/constants.js";
import { setSearchQuery } from "../actions/main.js";
import { connect } from "react-redux";
import "../App.scss";

class SelectCity extends Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
    this.state = {
      isLoading: false,
      multiple: false,
      options: [],
      isTypeaheadFocus: true
    };
    console.log(this.props);
  }

  componentDidMount() {
    this._typeahead.getInstance().focus();
  }

  _handleSearch = query => {
    this.setState({ isLoading: true });
    const newArray = citiesData.filter(city =>
      city.value
        .toString()
        .toLowerCase()
        .includes(query.toString().toLowerCase())
    );
    this.setState({
      isLoading: false,
      options: newArray
    });
  };

  handleOnChange = selected => {
    //debugger;
    if (selected) {
      const query = {
        type: this.props.match.params.type,
        data: {
          city: selected.value,
          masterId: selected.masterId
        }
      };
      // console.log(query);
      this.props.setSearchQuery(query);
      //console.log(this.props);
      if (query.type === "source") {
        window.localStorage.setItem(
          LOCALSTORAGE_KEY.SOURCE_CITY,
          JSON.stringify(query)
        );
      }
      if (query.type === "destination") {
        window.localStorage.setItem(
          LOCALSTORAGE_KEY.DESTINATION_CITY,
          JSON.stringify(query)
        );
      }
      this.props.history.goBack();
    }
  };

  render() {
    const popularCityList = Config.POPULAR_CITIES.map((s, i) => (
      <div className="item" key={i} onClick={() => this.handleOnChange(s)}>
        <i className="material-icons">directions_bus</i>&nbsp;&nbsp;&nbsp;
        <span>{s.value}</span>
      </div>
    ));

    const popularSearchBlock = (
      <div className="popular-search">
        <div className="title">POPULAR SEARCH</div>
        <hr />
        {popularCityList}
      </div>
    );

    return (
      <div>
        <Grid container justify="flex-start" className="header-summary">
          <Grid item xs={1} className="backBtn">
            <i
              className="material-icons"
              onClick={() => {
                this.props.history.goBack();
              }}
            >
              arrow_back
            </i>
          </Grid>
          <Grid item xs={11} className="title">
            Select City
          </Grid>
        </Grid>

        <div className="station-select">
          <Fragment>
            <AsyncTypeahead
              id="list"
              ref={ref => (this._typeahead = ref)}
              {...this.state}
              onSearch={this._handleSearch}
              placeholder="Search City"
              maxHeight="350px"
              labelKey={option => option.value}
              onChange={selected => {
                this.handleOnChange(selected[0]);
                this._typeahead.getInstance().blur();
              }}
            />
          </Fragment>
          {popularSearchBlock}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setSearchQuery: query => {
      dispatch(setSearchQuery(query));
    }
  };
};

const mapStateToProps = state => {
  return {
    searchQuery: state.searchReducer
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectCity);
